import {useTileAnimation, type TileProps} from './types'

export const Tile3 = ({className, colors, delay}: TileProps) => {
  const svgRef = useTileAnimation({
    delay,
    selector: 'rect',
    scaleProperty: 'scale',
    transformOrigin: 'center',
  })

  return (
    <svg
      ref={svgRef}
      className={className}
      width="400"
      height="146"
      viewBox="0 0 400 146"
      fill="none"
      aria-hidden="true"
    >
      <rect width="400" height="155" transform="matrix(-1 0 0 1 400 -3.55859)" fill={colors[0]} />
      <rect x="34" y="58.4541" width="27.4684" height="28.1224" fill={colors[1]} />
      <rect x="85.6665" y="7.44141" width="27.4684" height="28.1224" fill={colors[1]} />
      <rect x="85.6665" y="112.083" width="27.4684" height="28.1224" fill={colors[1]} />
      <rect x="137.987" y="58.4541" width="27.4684" height="28.1224" fill={colors[1]} />
      <rect x="191.616" y="7.44141" width="27.4684" height="28.1224" fill={colors[1]} />
      <rect x="191.616" y="112.083" width="27.4684" height="28.1224" fill={colors[1]} />
      <rect x="241.975" y="58.4541" width="27.4684" height="28.1224" fill={colors[1]} />
      <rect x="290" y="7.44141" width="27.4684" height="28.1224" fill={colors[1]} />
      <rect x="290" y="112.083" width="27.4684" height="28.1224" fill={colors[1]} />
      <rect x="342.321" y="58.4541" width="27.4684" height="28.1224" fill={colors[1]} />
    </svg>
  )
}
